import BordTableWithActions from 'components/NudosComponents/BordTableWithActions/BordTableWithActions';
import { HISTORY_HEADERS } from '../../constants';
import { useEffect, useState } from 'react';
import { getCatalogHistory, getOrdersHistory } from 'services/bulkUpload/bulkUploadHistory.service';
import { BULK_UPLOAD_TYPE_ID, IBulkUploadHistoryItem } from '../../TypeOfCharge.types';
import { mapCatalogUploadHistoryData, mapOrdersUploadHistoryData } from '../../TypeOfCharge.mapper';
import useUsersState from 'state/useUsersState';
import UserInfo from 'components/UserInfo/UserInfo';
import LoadStatus from '../LoadStatus/LoadStatus';
import HistoryTemplate from '../HistoryTemplate/HistoryTemplate';
import { historyActions } from '../../content/UploadHistoryContent';
import './UploadHistory.scss';

const UploadHistory = () => {
  const [data, setData] = useState<(string | number | React.ReactNode)[][]>([]);
  const [typeOfChargeSelected, setTypeOfChargeSelected] = useState<BULK_UPLOAD_TYPE_ID>(BULK_UPLOAD_TYPE_ID.CATALOG);
  const { users } = useUsersState();

  const handleTypeOfChargeChange = (value: BULK_UPLOAD_TYPE_ID) => {
    if (!value) return;
    setTypeOfChargeSelected(value);
  };

  const actions = historyActions({
    actions: [handleTypeOfChargeChange],
    values: [typeOfChargeSelected]
  });

  const headers = HISTORY_HEADERS;

  const fetchHistoryData = async () => {
    let formatedData: IBulkUploadHistoryItem[] = [];
    if (typeOfChargeSelected === BULK_UPLOAD_TYPE_ID.CATALOG) {
      const historyData = await getCatalogHistory();
      formatedData = mapCatalogUploadHistoryData(historyData, users);
    } else {
      const historyData = await getOrdersHistory();
      formatedData = mapOrdersUploadHistoryData(historyData, users);
    }
    setData(
      formatedData.map((item: IBulkUploadHistoryItem) => [
        item.date,
        item.loadId,
        <UserInfo
          firstName={item.responsible.firstName}
          lastName={item.responsible.lastName}
          email={item.responsible.email}
          profilePhoto={item.responsible.avatar}
        />,
        <LoadStatus {...item.loadStatus} />,
        <HistoryTemplate templateLink={item.template} />
      ])
    );
  };

  useEffect(() => {
    if (users && typeOfChargeSelected) fetchHistoryData();
  }, [users, typeOfChargeSelected]);

  return (
    <section className="uploadHistory">
      <BordTableWithActions
        title={
          BULK_UPLOAD_TYPE_ID.CATALOG === typeOfChargeSelected
            ? 'Historial de cargue de catálogo'
            : 'Historial de cargue de órdenes'
        }
        actions={actions}
        headers={headers}
        data={data}
        className="uploadHistoryWithActions"
        tableClassName="uploadHistoryTable"
      />
    </section>
  );
};

export default UploadHistory;
